export enum SmartCartFormTab {
  ORDER_MANAGEMENT = 'order-management',
  GLOBAL_SETTINGS = 'global-settings',
}

export interface SmartCartFormTabConfig {
  label: string;
  value: SmartCartFormTab;
}

export type SmartCartLayoutSectionId = 'header' | 'body' | 'footer';

export interface SmartCartLayoutSection {
  id: SmartCartLayoutSectionId;
  label: string;
}

export interface LoadedWidget {
  id: number;
  type: string;
  enabled: boolean;
  order: number;
  usageToken?: string;
  settings: Record<string, unknown>;
}

export type LoadedWidgetsBySection = Record<SmartCartLayoutSectionId, LoadedWidget[]>;
